import { Injectable } from '@angular/core';
import { FleetDto } from '@pages/fleet/interfaces';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FleetFilteredItemsService {
  fleetGridFilterChanged$: BehaviorSubject<FleetDto[]> = new BehaviorSubject<
    FleetDto[]
  >([]);
}
